import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

summaryTableStyles.orderLines = {
    gridContainer:{
        css:css` .card_container__wrapper {
            border-top: 1px solid ${getColor("common.border")};
            > div{
                padding: 37px 5px ;
            }
        }`,
    }

}